module.exports = __webpack_public_path__ + "img/overseas-business-wechat-official-accounts_1.b8db6cc1.png";